import path from 'path';
import dotenv from 'dotenv';

dotenv.config();

const CONFIG_DIR = ".superpush";
const CONFIG_DIR_PATH = path.join(process.cwd(), CONFIG_DIR);

export const CONFIGS = {
  PROJECT_DIR: path.basename(process.cwd()),
  CONFIG_DIR,
  CONFIG_DIR_PATH,
  ANDROID: "android",
  ANDROID_BUNDLE_OUTPUT: `${CONFIG_DIR}/android/index.android.bundle`,
  ANDROID_ASSET_DESTINATION: `${CONFIG_DIR}/android`,
  IOS: "ios",
  IOS_BUNDLE_OUTPUT: `${CONFIG_DIR}/ios/main.jsbundle`,
  IOS_ASSET_DESTINATION: `${CONFIG_DIR}/ios`,
  API_BASE_URL: "https://superpush-api.superpe.in",
  API_VERSION: "/api/v1",
};
